module.exports = {
	"text/jade": [
		"jade"
	],
	"text/stylus": [
		"stylus",
		"styl"
	],
	"text/less": [
		"less"
	],
	"text/x-sass": [
		"sass"
	],
	"text/x-scss": [
		"scss"
	],
	"text/coffeescript": [
		"coffee"
	],
	"text/x-handlebars-template": [
		"hbs"
	],
	"text/jsx": [
		"jsx"
	]
};


//////////////////
// WEBPACK FOOTER
// ./~/fhir.js/~/mime-types/lib/custom.json
// module id = 1239
// module chunks = 0